<template>
  <div>
    <el-descriptions title="" :column="1" v-if="!editBuildings">
      <el-descriptions-item
        v-for="(v, i) in buildingsList"
        :key="i"
        :label="v.name"
        >{{ v.num }}{{ v.unit }}</el-descriptions-item
      >
    </el-descriptions>
    <el-form label-position="right" label-width="100px" v-else>
      <el-form-item :label="v.name" v-for="(v, i) in buildingsList" :key="i">
        <el-input v-model="v.num" style="width: 50%"> </el-input>
        <span style="margin-left: 10px">{{ v.unit }}</span>
      </el-form-item>
    </el-form>
    <div style="text-align: right">
      <el-button
        type="primary"
        v-if="!editBuildings"
        @click="editBuildings = true"
        >修改建筑信息</el-button
      >
      <template v-else>
        <el-button @click="editBuildings = false">返 回</el-button>
        <el-button type="primary">确认修改</el-button>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      editBuildings: false,
      buildingsList: [
        { name: "建筑楼栋数量", num: "45", unit: "栋" },
        { name: "建筑面积", num: "32212", unit: "㎡" },
        { name: "房间数量", num: "531", unit: "间" },
        { name: "总人数", num: "4578", unit: "人" },
      ],
    };
  },
};
</script>

<style>
</style>